



































import { Component, Vue } from 'vue-property-decorator';
import ModalPlugin, { ModalData } from './index';

@Component
export default class Modal extends Vue {

  /** Is the v-dialog component loaded. */
  private loaded = false;

  /** Dialog model. */
  private dialog = false;

  /** Modal data displayed. */
  private data: ModalData|null = {};

  beforeMount() {
    // Initialize modal event listener.
    ModalPlugin.register(this.open);
  }

  /** Open the modal with given data. */
  private open(data: ModalData) {
    this.loaded = true;
    this.dialog = true;
    this.data = data;
  }

  /** Close the modal. */
  private close(action?: () => void) {
    this.dialog = false;
    if (action) action();
    // Do not reset data directly because of fade effect.
    setTimeout(() => {
      if (!this.dialog) {
        this.data = {};
      }
    }, 200);
  }
}

